import React from 'react';

import { RadioButtonGroup } from 'commonsComponents/radioButtonGroup';
import { RadioButton } from 'commonsComponents/radioButton';
import 'react-virtualized/styles.css';
const { formatText } = require('core/i18n').i18n;

export const DocumentsRadioButton = ({
    currentDocument,
    updateRadioButtonDocumentList
}) => {

    const handleYesNoSignedDocuments = e => {
        updateRadioButtonDocumentList(currentDocument, e == 'yes' ? true : false);
    };
    return (


        <div className="modal-mortgage-request-holder-radio-button">
            <p>{formatText(`hireCardtStep-titleOfficeRadio`)}</p>
            <RadioButtonGroup
                onChange={handleYesNoSignedDocuments}
                selectedValue={currentDocument.radioButton === null ? '' : (currentDocument.radioButton ? 'yes' : 'no')}
                idPrefix="newRadioPrintedDocument"
                isHorizontal={false}
                name="newRadioPrintedDocument">
                <RadioButton label={formatText('officePrinter-yesRadioOption')} value={'yes'} className="signature-pattern__printed-documents-radio" />
                <RadioButton label={formatText('officePrinter-noRadioOption')} value={'no'} className="signature-pattern__printed-documents-radio" />
            </RadioButtonGroup>
        </div>


    );
};
